module.exports = __webpack_public_path__ + "img/11_NSC_innen_iPad_L.36979a37.jpg";